import React, { useState } from 'react';
import { Tooltip, IconButton, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const InfoTooltip = ({ 
  text, 
  placement = 'top', 
  size = 'small',
  color = 'primary',
  sx = {}
}) => {
  const [open, setOpen] = useState(false);

  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box 
      component="span" 
      sx={{ 
        display: 'inline-flex', 
        alignItems: 'center',
        ml: 0.5,
        ...sx 
      }}
    >
      <Tooltip
        title={text}
        placement={placement}
        open={open}
        onClose={handleClose}
        onOpen={() => setOpen(true)}
        arrow
        PopperProps={{
          disablePortal: false,
          style: { zIndex: 9999 }
        }}
        componentsProps={{
          tooltip: {
            sx: {
              maxWidth: 300,
              fontSize: '0.875rem',
              lineHeight: 1.4,
              bgcolor: 'rgba(97, 97, 97, 0.95)',
              zIndex: 9999,
              '& .MuiTooltip-arrow': {
                color: 'rgba(97, 97, 97, 0.95)',
              },
            },
          },
        }}
      >
        <IconButton
          size={size}
          color={color}
          onClick={handleClick}
          onMouseEnter={(e) => {
            e.stopPropagation();
            setOpen(true);
          }}
          onMouseLeave={(e) => {
            e.stopPropagation();
            setOpen(false);
          }}
          sx={{
            padding: '2px',
            zIndex: 1000,
            position: 'relative',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
          }}
        >
          <InfoIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default InfoTooltip;
